import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { fetchFavoriteReports } from '../api/favoritesApi';
import requestStatusType from '../constants/requestStatusTypes';
const {
  UNINITIALIZED,
  PENDING,
  SUCCEEDED,
  FAILED
} = requestStatusType;
export const favoritesNamespace = 'favorites';

// Action types
const FETCH_FAVORITES_PENDING = 'FETCH_FAVORITES_PENDING';
const FETCH_FAVORITES_SUCCEEDED = 'FETCH_FAVORITES_SUCCEEDED';
const FETCH_FAVORITES_FAILED = 'FETCH_FAVORITES_FAILED';
export const ADD_FAVORITE_SUCCEEDED = 'ADD_FAVORITE_SUCCEEDED';
export const REMOVE_FAVORITE_SUCCEEDED = 'REMOVE_FAVORITE_SUCCEEDED';
// Actions
export const fetchFavorites = () => dispatch => {
  dispatch({
    type: FETCH_FAVORITES_PENDING
  });
  return fetchFavoriteReports().then(response => {
    dispatch({
      type: FETCH_FAVORITES_SUCCEEDED,
      payload: response
    });
  }, error => {
    console.error(error); // eslint-disable-line no-console
    dispatch({
      type: FETCH_FAVORITES_FAILED,
      payload: error
    });
  });
};
// Reducers
const initialState = fromJS({
  status: UNINITIALIZED,
  favorites: []
});
export const favoritesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FAVORITES_PENDING:
      return state.set('status', PENDING);
    case FETCH_FAVORITES_SUCCEEDED:
      return state.set('status', SUCCEEDED).set('favorites', action.payload.map(favorite => favorite.get('objectId')));
    case FETCH_FAVORITES_FAILED:
      return state.set('status', FAILED);
    case ADD_FAVORITE_SUCCEEDED:
      return state.updateIn(['favorites'], favorites => favorites.push(action.payload));
    case REMOVE_FAVORITE_SUCCEEDED:
      return state.updateIn(['favorites'], favorites => favorites.delete(favorites.indexOf(action.payload)));
    default:
      return state;
  }
};

// Selectors
export const selectFavoritesRoot = state => state[favoritesNamespace];
export const selectFavoriteReports = createSelector(selectFavoritesRoot, favoritesRoot => favoritesRoot.get('favorites'));
export const selectFavoriteReportsStatus = createSelector(selectFavoritesRoot, favoritesRoot => favoritesRoot.get('status'));